var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjDivider", { attrs: { "right-fixed": "" } }, [
        _vm._v(_vm._s(_vm.$t("billingPage.ManualHistory"))),
      ]),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "label-width": "80px",
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: false,
        },
        on: {
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.Category"),
                          prop: "categoryCode",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.categoryCodeList,
                            placeholder: _vm.$t("chooseText"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.categoryCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "categoryCode", $$v)
                            },
                            expression: "queryParams.categoryCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.yearAndWeek"),
                          prop: "year",
                        },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            id: "getWeekDate",
                            "picker-options": { firstDayOfWeek: 1 },
                            type: "week",
                            format: "yyyy-WW",
                            clearable: false,
                            placeholder: _vm.$t("billingPage.yearAndWeeks"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.weekDataNow,
                            callback: function ($$v) {
                              _vm.weekDataNow = $$v
                            },
                            expression: "weekDataNow",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SalesOrderToBeApproved.form.Approval"),
                          prop: "categoryCode",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.TAB_LIST2,
                            placeholder: _vm.$t("chooseText"),
                            clearable: false,
                          },
                          on: { change: _vm.changeCategoryCode },
                          model: {
                            value: _vm.tabValue2,
                            callback: function ($$v) {
                              _vm.tabValue2 = $$v
                            },
                            expression: "tabValue2",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.onAdd("NORMAL")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("billingPage.normal")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.onAdd("DISPO_FEE")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("billingPage.once")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    col.prop == "transNo"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#3173d0" },
                                            },
                                            [_vm._v(_vm._s(scope.row.transNo))]
                                          ),
                                          _c("BjCopyIcon", {
                                            attrs: { copy: scope.row.transNo },
                                          }),
                                        ]
                                      : col.prop == "clientCode"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#3173d0" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row.clientCode)
                                              ),
                                            ]
                                          ),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row.clientCode,
                                            },
                                          }),
                                        ]
                                      : col.prop == "billCategory.name"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.billCategory.name
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop == "weekyear"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.year) +
                                              " / " +
                                              _vm._s(scope.row.week) +
                                              " "
                                          ),
                                        ]
                                      : col.prop == "gmtCreate"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("timeFilters")(
                                                  scope.row.gmtCreate,
                                                  scope.row.gmtCreate
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ],
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "edit-btn",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDetail(props.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("viewText")))]
                                      ),
                                      _c(
                                        "el-dropdown",
                                        {
                                          directives: [
                                            {
                                              name: "hasDropdownChildren",
                                              rawName: "v-hasDropdownChildren",
                                            },
                                          ],
                                          on: {
                                            command: function ($event) {
                                              return _vm.command(
                                                $event,
                                                props.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "el-dropdown-link" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "AccountManagement.common.operate"
                                                  )
                                                )
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-arrow-down el-icon--right",
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              slot: "dropdown",
                                            },
                                            [
                                              _vm.tabValue2 == 2
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "permission",
                                                          rawName:
                                                            "v-permission:BillingManualChargeAuditIsPass",
                                                          arg: "BillingManualChargeAuditIsPass",
                                                        },
                                                      ],
                                                      attrs: { command: "1" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "auditPassText"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.tabValue2 == 2
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "permission",
                                                          rawName:
                                                            "v-permission:BillingManualChargeAuditIsPass",
                                                          arg: "BillingManualChargeAuditIsPass",
                                                        },
                                                      ],
                                                      attrs: { command: "2" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "auditNotPassText"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "el-dropdown-item",
                                                { attrs: { command: "3" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("editText")) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "el-dropdown-item",
                                                { attrs: { command: "4" } },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("delText")
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("viewChargeDialog", {
        ref: "chargeDialogRef",
        on: { reject: _vm.onReject, edit: _vm.onEdit },
      }),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, "before-close": _vm.onReset },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.tabValue == "NORMAL"
            ? _c("normal-form", {
                ref: "NormalFormRef",
                attrs: {
                  "client-code-list": _vm.clientCodeList,
                  "category-code-list": _vm.categoryCodeList,
                },
              })
            : _vm._e(),
          _vm.tabValue == "DISPO_FEE"
            ? _c("dispo-form", {
                ref: "DispoFormRef",
                attrs: { "client-code-list": _vm.clientCodeList },
              })
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onReset } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onSave("form")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }